import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TnbUser } from './tnb-user';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {

    private http = inject(HttpClient);

    public getProfile(): Observable<TnbUser> {
        return this.http.get<TnbUser>(environment.API_URL + '/profile');
    }
}
